import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {DeleteViewContent} from '../components/delete/DeleteViewContent'
import {CodeViewHeaderDataRouter} from '../components/headers/CodeViewHeader'
import {DeleteHeaderButtons} from '../components/headers/header-components/DeleteHeaderButtons'
import {codeViewTreeDeleteRoute} from '../routes/code-view-tree-delete-route'
import {CodeView} from './CodeView'

export function CodeViewTreeDeleteEntrypoint() {
  const {data: payload} = useRouteQuery(codeViewTreeDeleteRoute, 'mainQuery')

  const actions = <DeleteHeaderButtons webCommitInfo={payload.webCommitInfo} isBlob={payload.deleteInfo.isBlob} />

  return (
    <>
      <CodeViewHeaderDataRouter
        narrowActions={actions}
        wideActions={actions}
        commitish={payload.refInfo.name}
        path={payload.path}
        modelsRepoIntegrationEnabled={payload.modelsRepoIntegrationEnabled}
      />
      <CodeView payload={payload} action="tree">
        {() => <DeleteViewContent deleteInfo={payload.deleteInfo} webCommitInfo={payload.webCommitInfo} />}
      </CodeView>
    </>
  )
}
